import axios from "axios";
import { ReservationsApiError } from "constants/customErrors";

import logError from "utils/logError";

import reservationApi, {
  ReservationsApiErrors,
  ReservationsApiErrorsResponse,
} from "../services/reservations";

type OrderRequestBody = {
  reservation: {
    cartId?: number;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    emailAddress: string;
    embedVersion?: string | null;
    dateOfBirth: string;
    saveUserInfo: boolean;
    total?: number;
    subtotal?: number;
    externalOrderId?: string | null;
    tax?: number;
    menuType: string | null;
    fulfillmentMechanism: string;
    city?: string | null;
    state?: string | null;
    postal_code?: string | null;
    address1?: string | null;
    address2?: string | null;
    paymentPreference?: string | null;
    deliveryInstructions?: string | null;
    coordinates?: {
      lat: number;
      lng: number;
    };
    addressType?: string | null;
  };
};

const createAndLogErrors = (errors: ReservationsApiErrors) =>
  errors.map((error) => {
    logError(error.detail, {
      functionName: "createOrder",
      service: "reservations",
    });
    return new ReservationsApiError(error);
  });

const createOrder = async (sessionId: string, orderBody: OrderRequestBody) => {
  try {
    const { data } = await reservationApi.post("/reservations", orderBody, {
      headers: {
        "X-Leafly-Id": sessionId,
      },
    });

    if (data.errors) {
      throw data.errors;
    }

    return data;
  } catch (e) {
    const errorData =
      axios.isAxiosError(e) &&
      (e.response?.data as ReservationsApiErrorsResponse)?.errors;

    if (errorData) {
      const errors = createAndLogErrors(errorData);

      throw errors;
    } else if (Array.isArray(e)) {
      const errors = createAndLogErrors(e as ReservationsApiErrors);

      throw errors;
    } else {
      logError(e.message || "reservationUnknownError", {
        functionName: "createOrder",
        service: "reservations",
        statusCode: e.code || "UNKNOWN",
      });

      throw e;
    }
  }
};

export default createOrder;
